import { Component, OnChanges, EventEmitter } from '@angular/core';
import { filter } from 'rxjs/operators';
import { BaseComponent } from '../../shared/base-components/base.component';
import { ModalSize } from '../../shared/services/modal/mvd-modal.enum';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { CustomerIndividualMedicalAlert } from '../models/customer-individual-medical-alert.model';
import { CustomerIndividualMedicalAlertType } from '../models/enums/customer-individual-medical-alert-type.enum';
import { CustomerManageService } from '../shared/customer-manage.service';
import { MedicalAlertContext, MedicalAlertModalComponent } from './customer-medical-modal.component';
import { HistoricalCustomerMedicalAlertModalComponent, HistoricalMedicalAlertContext } from './historical-customer-medical-modal.component';

@Component({
    selector: 'customer-medical-alerts',
    templateUrl: './customer-medical.html',
    inputs: ['customerNumber', 'alerts', 'canEdit'],
    outputs: ['onMedicalAlertsChange']

})
export class CustomerMedicalComponent extends BaseComponent implements OnChanges {
    public alerts: CustomerIndividualMedicalAlert[];
    public customerNumber: number;
    public canEdit: boolean;
    public onMedicalAlertsChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    private alertTypes = new CustomerIndividualMedicalAlertType();

    constructor(
        public modalService: MvdModalService,
        private customerService: CustomerManageService) {
        super();
    }

    ngOnInit() {
        if (this.customerNumber != null) {
            this.populateAlerts(this.customerNumber);
        } else if (this.alerts != null) {
            this.denormalizeData();
        }
    }

    ngOnChanges() {
        if (this.customerNumber != null) {
            this.populateAlerts(this.customerNumber);
        } else if (this.alerts != null) {
            this.denormalizeData();
        }
    }

    populateAlerts(customerNumberId: number) {
        this.customerService.getCustomerMedicalAlerts(customerNumberId)
            .subscribe(result => {
                this.alerts = result;
            },
            e => console.log('error', e),
            () => {
                this.denormalizeData();
            });
    }

    denormalizeData() {
        for (const alert of this.alerts) {
            alert.alertType = this.getValues(alert.customerIndividualMedicalAlertTypeId, this.alertTypes);
        }
    }

    getValues(id: number, types: any): string {
        if (id !== undefined && id !== null) {
            return types.FromId(id).displayValue;
        } else {
            return '';
        }
    }

    addAlert() {
        const data = new MedicalAlertContext(0, this.customerNumber );
        this.modalService.open(MedicalAlertModalComponent, data, ModalSize.Medium).afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(() => {
                this.onMedicalAlertsChange.emit();
                this.populateAlerts(this.customerNumber);
            });
    }

    editAlert(id) {
        const data = new MedicalAlertContext(id, this.customerNumber);
        this.modalService.open(MedicalAlertModalComponent, data, ModalSize.Medium).afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(() => {
                this.onMedicalAlertsChange.emit();
                this.populateAlerts(this.customerNumber);
            });
    }

    showHistory(id) {
        const data = new HistoricalMedicalAlertContext(this.customerNumber);
        this.modalService.open(HistoricalCustomerMedicalAlertModalComponent, data);
    }
}
